import React, { HTMLAttributes, ReactNode } from 'react'

import { gaEvents } from '../logic/ga4'

import './EmailLink.scss'

export const EmailLink = React.forwardRef<
  HTMLAnchorElement,
  {
    children: ReactNode
    email: string
    location: string
  } & HTMLAttributes<HTMLAnchorElement>
>(({ children, email, location, ...props }, ref) => (
  <a
    className="emailLink"
    onClick={() => gaEvents.emailCopied(email, location)}
    onCopy={() => gaEvents.emailCopied(email, location)}
    href={`mailto:${email}`}
    {...props}
    ref={ref}
  >
    {children}
  </a>
))
